import * as React from 'react';
import { useSelector } from 'react-redux';
import { trackClickGenplanSeoLink } from './tracking';
import { SeoMortgageLink as SeoMortgageLinkComponent } from '../../components/SeoMortgageLink';
import { genplanSeoPageUrlSelector } from '../../selectors/seoPages';

export const SeoGenplanLink = () => {
  const url = useSelector(genplanSeoPageUrlSelector);

  return (
    <SeoMortgageLinkComponent url={url} onClick={trackClickGenplanSeoLink} title="Генплан" testId="seo_genplan_link" />
  );
};
